import React from 'react';
import { Card } from 'primereact/card';
import { Tag } from 'primereact/tag';
import AgendaEmptyState from './AgendaEmptyState';
import VisitCard from './VisitCard';
import { formatDayNumber, getVisibleWeekDays, getVisitsForDate, isToday } from '../utils/agendaDates';

const WeeklyAgendaView = ({
    selectedDate,
    weekDays: providedWeekDays,
    visits,
    canEditVisits,
    canStartVisit,
    canFinishVisit,
    canReportVisit,
    canViewReport,
    isReportLocked,
    actionLoadingVisitId,
    locationLoadingVisitId,
    onEditVisit,
    onCancelVisit,
    onStartVisit,
    onFinishVisit,
    onReportVisit
}) => {
    const weekDays = providedWeekDays?.length ? providedWeekDays : getVisibleWeekDays(selectedDate);

    return (
        <div className="ventas-week-grid">
            {weekDays.map((day) => {
                const dayVisits = getVisitsForDate(visits, day.date);
                const clientVisits = dayVisits.filter((visit) => visit?.activityType !== 'office');
                const officeActivities = dayVisits.filter((visit) => visit?.activityType === 'office' && visit?.planningStatus !== 'cancelled');
                const plannedVisits = clientVisits.filter((visit) => visit?.planningStatus !== 'cancelled' && visit?.visitOrigin !== 'unplanned');
                const unplannedVisits = clientVisits.filter((visit) => visit?.planningStatus !== 'cancelled' && visit?.visitOrigin === 'unplanned');
                const pendingReportVisits = clientVisits.filter((visit) => visit?.executionStatus === 'pendingReport');
                const completedReportVisits = clientVisits.filter((visit) => visit?.executionStatus === 'completed' && visit?.planningStatus !== 'cancelled');
                const dayIsToday = isToday(day.date);

                return (
                    <Card key={day.label} className={`ventas-week-day-card${dayIsToday ? ' ventas-week-day-card--today' : ''}`}>
                        <div className="flex align-items-start justify-content-between gap-2 mb-3">
                            <div>
                                <div className="flex align-items-center gap-2 flex-wrap">
                                    <h4 className="m-0">{day.label}</h4>
                                    {dayIsToday ? <Tag value="Hoy" severity="info" /> : null}
                                </div>
                                <div className="ventas-day-number">{formatDayNumber(day.date)}</div>
                            </div>
                            <div className="flex gap-2 flex-wrap justify-content-end">
                                <Tag value={`${plannedVisits.length} planificadas`} severity="secondary" />
                                {officeActivities.length ? <Tag value={`${officeActivities.length} oficina`} severity="info" /> : null}
                                {unplannedVisits.length ? <Tag value={`${unplannedVisits.length} no planificadas`} severity="warning" /> : null}
                                {pendingReportVisits.length ? <Tag value={`${pendingReportVisits.length} pendientes`} severity="warning" /> : null}
                                {completedReportVisits.length ? <Tag value={`${completedReportVisits.length} reportes`} severity="success" /> : null}
                            </div>
                        </div>

                        <div className="ventas-visits-area ventas-visit-list">
                            {dayVisits.length ? (
                                dayVisits.map((visit) => (
                                    <VisitCard
                                        key={visit._id}
                                        visit={visit}
                                        compact
                                        canEdit={typeof canEditVisits === 'function' ? canEditVisits(visit) : canEditVisits}
                                        canStart={canStartVisit?.(visit)}
                                        canFinish={canFinishVisit?.(visit)}
                                        canReport={canReportVisit?.(visit)}
                                        canViewReport={canViewReport?.(visit)}
                                        reportLocked={isReportLocked?.(visit)}
                                        actionLoading={actionLoadingVisitId === visit._id}
                                        locationLoading={locationLoadingVisitId === visit._id}
                                        onEdit={onEditVisit}
                                        onCancel={onCancelVisit}
                                        onStart={onStartVisit}
                                        onFinish={onFinishVisit}
                                        onReport={onReportVisit}
                                    />
                                ))
                            ) : (
                                <AgendaEmptyState message="No hay visitas ni actividades planificadas." />
                            )}
                        </div>
                    </Card>
                );
            })}
        </div>
    );
};

export default WeeklyAgendaView;
